import React from 'react';
import { cn } from '../../utils/cn';
export type KpiAccent = 'green' | 'leaf' | 'navy' | 'gold' | 'red' | 'sky';
interface KpiCardProps {
  label: string;
  value: string;
  meta?: string;
  accent?: KpiAccent;
  tone?: 'default' | 'warn' | 'risk';
}
const accentBar: Record<KpiAccent, string> = {
  green: 'bg-uae-green',
  leaf: 'bg-uae-leaf',
  navy: 'bg-uae-navy',
  gold: 'bg-uae-gold',
  red: 'bg-uae-red',
  sky: 'bg-uae-sky'
};
const valueTone: Record<string, string> = {
  default: 'text-foreground',
  warn: 'text-uae-bronze',
  risk: 'text-uae-red'
};
export function KpiCard({
  label,
  value,
  meta,
  accent = 'green',
  tone = 'default'
}: KpiCardProps) {
  return <div className="relative overflow-hidden rounded-sm border border-border bg-card pl-4 pr-4 py-3" data-id="element-557" data-mp="ou0iek6wl25n">
      <span className={cn('absolute inset-y-0 left-0 w-1', accentBar[accent])} aria-hidden="true" data-id="element-558" data-mp="13qriywsbcjwu" />
      <p className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-559" data-mp="ysprpokqheaa">{label}</p>
      <p className={cn('mt-1.5 text-2xl font-semibold tabular tracking-tight', valueTone[tone])} data-id="element-560" data-mp="3q71dtncf79td">
        {value}
      </p>
      {meta && <p className="mt-1 text-[11px] text-muted-foreground" data-id="element-561" data-mp="3v5w3n98t1ymz">{meta}</p>}
    </div>;
}